import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/merchant/login" element={<Login />} />
        <Route
          path="/merchant/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/merchant/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/merchant/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
